<template>
  <div class="pa-0 text-xs-center" style="user-select:none;">
    <v-avatar v-if="this.avatar !== ''"
      :size="size"
      @click="onClicked" 
    >
      <v-img 
        aspect-ratio="1:1"
        :src="getAvatar" />
    </v-avatar>
    <!-- else -->
    <v-avatar v-else
      :size="size" 
      :color="backcolor"
      v-text="initials"
      @click="onClicked"
    />
  </div>
</template>

<style>
  .bc-F36C60 { background-color: #F36C60; }
  .bc-F06292 { background-color: #F06292; }
  .bc-BA68C8 { background-color: #BA68C8; }
  .bc-9575CD { background-color: #9575CD; }
  .bc-7986CB { background-color: #7986CB; }
  .bc-91A7FF { background-color: #91A7FF; }
  .bc-4FC3F7 { background-color: #4FC3F7; }
  .bc-4DD0E1 { background-color: #4DD0E1; }
  .bc-4DB6AC { background-color: #4DB6AC; }
  .bc-42BD41 { background-color: #42BD41; }
  .bc-AED581 { background-color: #AED581; }
  .bc-DCE775 { background-color: #DCE775; }
  .bc-FFF176 { background-color: #FFF176; }
  .bc-FFB74D { background-color: #FFB74D; }
  .bc-FF8A65 { background-color: #FF8A65; }
  .bc-FF8A65 { background-color: #FF8A65; }
  .bc-90A4AE { background-color: #90A4AE; }
</style>

<script> 
  import baseUtils from '@utils/base'

  export default {
    name: 'user-avatar',
    props: {
      avatar: {
        type: String,
        required: true
      },
      username: {
        type: String,
        required: true
      },
      size: {
        type: Number,
        default: 192
      },
      onClick: {
        type: Function,
        required: false
      }
    },
    computed: {
      initials() {
        if (!this.username) 
          return ""
        return baseUtils.getAvatarLetters(this.username).toUpperCase()
      },
      getAvatar() {
        return this.avatar !== '' ? 'data:image/jpg;base64,' + this.avatar : ''
      },
      backcolor() {
        const hash = baseUtils.hashCode(this.username)

        // TODO: maybe we must compute font size: css font size = calc(0.45 * this.size)?
        let font = 'font-weight-regular white--text '
        if (this.size > 96)
          font += 'display-1'
        else if (this.size > 40)
          font += 'title'
        else 
          font += 'body-1'

        const colors = [
          'bc-F36C60',
          'bc-F06292',
          'bc-BA68C8',
          'bc-9575CD',
          'bc-7986CB',
          'bc-91A7FF',
          'bc-4FC3F7',
          //'bc-4DD0E1',
          //'bc-4DB6AC',
          //'bc-42BD41',
          'bc-AED581',
          'bc-DCE775',
          'bc-FFF176',
          'bc-FFB74D',
          'bc-FF8A65',
          'bc-FF8A65',
          'bc-90A4AE',
        ]
        return font + ' ' + colors[hash % colors.length]
      }
    },
    methods: {
      onClicked() {
        if (this.onClick !== undefined)
          this.onClick()
      }
    }
  }
</script>